import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=23abc982&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=23abc982&scoped=true&lang=css&"
import style1 from "./Home.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abc982",
  null
  
)

export default component.exports